import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent } from '@ng-icons/core';
import { phosphorCheckBold } from '@ng-icons/phosphor-icons/bold';

export type ProgressVariant = 'continuous' | 'segmented';

@Component({
	selector: 'unir-ai-progress-route',
	standalone: true,
	imports: [CommonModule, NgIconComponent],
	templateUrl: './progress-route.component.html',
	styleUrl: './progress-route.component.scss'
})
export class ProgressRouteComponent {
	variant = input<ProgressVariant>('continuous');
	progress = input(0);
	totalSegments = input(4);
	size = input(2);
	strokeWidth = input(20);
	segmentWidth = input(4);
	icon = input<string>();
	trackColor = input('#b7dfff');
	progressColor = input('#008660');
	iconColor = input('#008660');
	borderColor = input('#c8c8c8');
	checkColor = input('#ffffff');

	icons: Record<string, string> = {
		check: phosphorCheckBold
	};

	readonly viewBox = computed(() => {
		const width = this.segmentWidth();
		return `${-width / 2} ${-width / 2} ${100 + width} ${100 + width}`;
	});

	readonly circleRadius = computed(() => (100 - this.strokeWidth()) / 2);
	readonly circleCircumference = computed(() => this.circleRadius() * 2 * Math.PI);
	readonly progressOffset = computed(() => this.circleCircumference() * (1 - this.progress() / 100));

	readonly borderY1 = computed(() => 50 - (this.circleRadius() + this.strokeWidth() / 2));
	readonly borderY2 = computed(() => 50 - (this.circleRadius() - this.strokeWidth() / 2));

	readonly borders = computed(() => {
		if (this.variant() !== 'segmented' || this.totalSegments() <= 0) {
			return [];
		}
		const numSegments = this.totalSegments();
		const angleStep = 360 / numSegments;
		return Array.from({ length: numSegments }, (_, i) => ({
			rotation: i * angleStep
		}));
	});

	floor(value: number): number {
		return Math.floor(value);
	}
}
